import { HttpClient, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, Facet, OccEndpointsService, OccProductSearchAdapter, PRODUCT_NORMALIZER } from '@spartacus/core';
import { FacetService } from '@spartacus/storefront';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  countDetails$ = new BehaviorSubject(null);
  selectedTabIndex = new BehaviorSubject(0);

  seperateDocDetails$ = new BehaviorSubject(null);
  seperateSoftDetails$ = new BehaviorSubject(null);  
  fromDetailPage$ = new BehaviorSubject<boolean>(false);
  docFormDetails: any;
  isDocpaginationClickEvent: boolean = false;
  softwareFormDetails: any;

  SteeringProdDetails$ = new BehaviorSubject(null);
  FormulaProdDetails$ = new BehaviorSubject(null);

  protected readonly codec = new HttpUrlEncodingCodec();
  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService,
    public searchService: OccProductSearchAdapter,
    public facetService: FacetService,
    private converterService:ConverterService
  ) {}

  getCrossRefDetails(pageSize, query, currentPage, sort?) {
    return this.http
      .get(
         this.occService.buildUrl('kbsearch/xref?fields=FULL', {
          queryParams: {
            pageSize,
            query,
            currentPage,
            sort,
          },
        })
      )
      .pipe(
        map((res: any) => {
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
          if (res.products) {
            res = { ...res,
               products:res.products.map((product)=> this.converterService.convert(product,PRODUCT_NORMALIZER)),
          };
        }
          return res;
        }),
        catchError((error) => {
          return of(null);
        })
      );
  }

  getDocumentDetails(pageSize, query, currentPage, sort?) {
    return this.http
      .get(
        this.occService.buildUrl('kbsearch/document?fields=FULL', {
          queryParams: {
            pageSize,
            query,
            currentPage,
            sort,
          },
        })
      )
      .pipe(
        map((res: any) => {
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
          if (res.products) {
            res = { ...res,
               products:res.products.map((product)=> this.converterService.convert(product,PRODUCT_NORMALIZER)),
          };
        }
          return res;
        }),
        catchError((error) => {
          return of(null);
        })
      );
  }

  getSoftwareDetails(pageSize, query, currentPage, sort?) {
    return this.http
      .get(
       
        this.occService.buildUrl('kbsearch/software?fields=FULL', {
          queryParams: {
            pageSize,
            query,
            currentPage,
            sort,
          },
        })
      )
      .pipe(
        map((res: any) => {
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
        
          return res;
        }),
        catchError((error) => {
          return of(null);
        })
      );
  }

  DecodeQuery(query) {
    // Decoding the query by replacing special characters with their respective characters
    const res = this.getLinkParams(query);
    return res!['query'];
  }

 
  getLinkParams(query: string): { [key: string]: string } {
    return {
      query: this.codec.decodeValue(
        this.processSpaces(this.decodeUriComponentSafe(query.replace(/\+/g, '%20')))
      ),
    };
  }
  
  protected decodeUriComponentSafe(query: string): string {
    return decodeURIComponent(
      query.replace(/%(?![0-9a-fA-F]{2})/g, '%25') // Ensure safe decoding
    );
  }
  
  // Function to modify consecutive `%20` occurrences
  protected processSpaces(query: string): string {
    return query.replace(/(%20)(?=%20%20)/g, '%2B'); // Replace middle occurrence in sequences of three
  }
  
  getCustomDocDetails(pageSize, query, currentPage, sort?) {
    return this.http.get(
     
      this.occService.buildUrl('kbsearch/document?fields=FULL', {
        queryParams: {
          pageSize,
          query,
          currentPage,
          sort,
        },
      })
    );
  }
  getCustomDocumentDetails(searchDetails, pageSize, currentPage, sort?) {
    if (!this.isDocpaginationClickEvent) {
      this.docFormDetails = searchDetails;
    }
    console.debug(searchDetails);
    return this.http
      .get(
        this.occService.buildUrl('mydocuments/kbdocument?fields=FULL', {
          queryParams: {
            pageSize,
            q:this.docFormDetails?.searchKey,
            docType:searchDetails?.docType,
            docCategory:searchDetails?.productCategory,
            docLanguage:searchDetails?.language,
            page:currentPage,
            sort,
          },
        })
      )
      .pipe(
        map((res: any) => {
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
          return res;
        })
      );
  }
  getCustomSoftwareDetails(searchDetails, pageSize, currentPage, sort?) {
    this.softwareFormDetails = searchDetails;
    return this.http
      .get(
      
        this.occService.buildUrl('softwareLibrary/kbsoftwares?fields=FULL', {
          queryParams: {
            pageSize,
            text:searchDetails?.searchKey,
            q:this.softwareFormDetails?.searchKey,
            packageType:searchDetails?.packageType,
            softwareType:searchDetails?.softwareType,
            softwareGroup: searchDetails?.softwareGroup,
            softwareLanguage:searchDetails?.language,
            page:currentPage,
            sort,
          },
        })
      )
      .pipe(
        map((res: any) => {
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
          return res;
        })
      );
  }
  getCustomSoftwareQuery(query: any) {
    this.softwareFormDetails.searchKey = this.DecodeQuery(query);
    return this.softwareFormDetails;
  }
  getCustomDocQuery(query: any) {
    this.docFormDetails.searchKey = this.DecodeQuery(query);
    return this.docFormDetails;
  }
  checkStockAvailability(orderType, productCode, quantity) {
    return this.http.get(
      this.occService.buildUrl(
        `products/stockAvailability?orderType=${orderType}&productCode=${productCode}&quantity=${quantity}`
      )
    );
  }
  getFacets(facets) {
    return facets.map((facetSource: Facet) => {
      const { topValues, ...facetTarget } = facetSource;
      facetTarget.topValueCount = topValues && topValues.length > 0 ? topValues.length : 5;
      return facetTarget;
    });
  }
}
